import React from "react";
import Select from "antd/lib/select";
import FormInput from "../../../../components/FormInput/FormInput";
import styles from "./SMFormSelect.module.css";
import { SizeType } from "antd/lib/config-provider/SizeContext";

export interface ISMFormSelectProps {
  id: string;
  labelText?: string | any;
  value: string | number;
  disabled?: boolean;
  onChange: any;
  options?: () => React.ReactNode | React.ReactNode[];
  wrapperClassName?: string;
  dropdownMatchSelectWidth?: boolean | number;
  validation?: any;
  allowClear?: boolean;
  useCustomStyles?: boolean;
  hasSecondaryValueSelected?: boolean;
  size?: SizeType;
  onClick?: (event: React.MouseEvent) => void;
}

const SMFormSelect: React.FC<ISMFormSelectProps> = (props) => {
  const {
    id,
    labelText,
    value,
    disabled,
    onChange,
    options,
    dropdownMatchSelectWidth = true,
    wrapperClassName,
    validation,
    allowClear = false,
    useCustomStyles = false,
    hasSecondaryValueSelected = false,
    size = "middle",
    onClick,
  } = props;

  return (
    <FormInput
      id={id}
      labelText={labelText}
      className={wrapperClassName}
      validation={validation}
      CustomInput={() => (
        <Select
          size={size}
          id={id}
          disabled={disabled}
          value={value.toString()}
          onChange={onChange}
          allowClear={allowClear}
          dropdownMatchSelectWidth={dropdownMatchSelectWidth}
          className={`${useCustomStyles ? styles.select : ""} ${
            hasSecondaryValueSelected
              ? styles.select_hasSecondaryValueSelected
              : ""
          }`}
          onClick={onClick}
        >
          {options && options()}
        </Select>
      )}
    />
  );
};

export default SMFormSelect;
